import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import LoadingScreen from "../LoadingScreen";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import { IoClose } from "react-icons/io5";
import { IoDocumentOutline } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { GiCrossMark } from "react-icons/gi";
import { IoPrintSharp } from "react-icons/io5";
import CityMaster from "./CityMaster";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";

const RouteMasterLog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [routeId, setRouteId] = useState("");
  const [routeName, setRouteName] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [days, setDays] = useState("");

  const [citylist, setcitylist] = useState([]);
  const [selfrom, setSelfrom] = useState("");
  const [selto, setSelto] = useState("");
  const [newRouteId, setNewRouteId] = useState(null);
  const [daystotake, setDaysToTake] = useState(null);
  const [distance, setDistance] = useState(null);
  // const [routename, setRouteName] = useState("");
  const [hourstotake, setHoursToTake] = useState("");
  const [islocal, setisLocal] = useState(false);
  const [selInterFrom, setSelInterFrom] = useState("");
  const [selInterTo, setSelInterTo] = useState("");
  const [interdistance, setInterDistance] = useState("");
  const [intermediate, setInterMediate] = useState([]);
  const [showInterMediate, setShowIntermediate] = useState(false);
  const [selectedRowIndex, setselectedRowIndex] = useState(null);
  const [routeend, setrouteend] = useState(false);
  const [search, setSearch] = useState("");
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [histintermediate, setHistIntermediate] = useState([]);
  const [hist, sethist] = useState(false);
  const [showCityMaster, setShowCityMaster] = useState(false);

  useEffect(() => {
    let totaldistance = 0;
    intermediate.forEach((item) => {
      totaldistance += parseFloat(item.DISTANCE);
    });
    setDistance(totaldistance);
  }, [intermediate]);

  const filteredData = data?.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "OM_ROUTE_ID",
        "OM_ROUTE_START",
        "OM_ROUTE_END",
        "OM_ROUTE_NAME",
        "OM_ROUTE_DISTANCE",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    // 407	MTVWGETNEWROUTEID
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=407`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setNewRouteId(response?.data[0]?.DOCNO);
      })
      .catch((error) => {
        console.error("Error fetching New Route Id : /getNewRouteId", error);
      });

    // 650	VWROUTEDETAILLIST
    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=650`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessiontoken,
    //     },
    //   })
    //   .then((response) => {
    //     setItem(response.data);
    //   })
    //   .catch((error) => {
    //     setIsLoading(false);
    //     console.error("Error fetching Route details: /getRoutes", error);
    //   });

    // 596	VWCITYMASTER
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=596`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setcitylist(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Location details: /getCities", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=652`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setData(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 652", err);
      });
  };

  // Adding into table ********************************************************************************
  const AddIntermediate = () => {
    if (!selInterFrom) {
      alert("kindly Supply the Intermediate From Location");
    } else if (!selInterTo) {
      alert("kindly Supply the Intermediate To Location");
    } else if (selInterFrom == selInterTo) {
      alert(
        "Intermediate From Location Cannnot be equal to Intermediate To Location",
      );
    } else if (Number(interdistance) <= 0) {
      alert("Kindly Supply Intermediate Distance greater than 0 ");
    } else {
      if (selInterTo == selto) {
        if (
          window.confirm(
            "You are reaching the end of Main Route , Do you want to continue ?",
          )
        ) {
          const newValue = {
            FROMCITY: selInterFrom,
            TOCCITY: selInterTo,
            DISTANCE: interdistance,
          };

          const existingRowIndex = intermediate.findIndex(
            (charge) =>
              charge.FROMCITY === newValue.FROMCITY &&
              charge.TOCCITY === newValue.TOCCITY,
          );

          if (existingRowIndex !== -1) {
            const updatedItems = [...intermediate];
            updatedItems[existingRowIndex] = newValue;
            setInterMediate(updatedItems);
          } else {
            setInterMediate([...intermediate, newValue]);
          }

          setShowIntermediate(true);
          clearAll();
        }
      } else {
        const newValue = {
          FROMCITY: selInterFrom,
          TOCCITY: selInterTo,
          DISTANCE: interdistance,
        };

        const existingRowIndex = intermediate.findIndex(
          (charge) =>
            charge.FROMCITY === newValue.FROMCITY &&
            charge.TOCCITY === newValue.TOCCITY,
        );

        if (existingRowIndex !== -1) {
          const updatedItems = [...intermediate];
          updatedItems[existingRowIndex] = newValue;
          setInterMediate(updatedItems);
        } else {
          setInterMediate([...intermediate, newValue]);
        }

        setShowIntermediate(true);
        clearAll();
      }
    }
  };

  const clearAll = () => {
    if (selto == selInterTo) {
      setSelInterFrom("");
      setSelInterTo("");
      setInterDistance("");
      setrouteend(true);
    } else {
      setSelInterFrom(selInterTo);
      setSelInterTo("");
      setInterDistance("");
    }
  };

  const RemoveInterMediate = () => {
    if (intermediate.length > 0) {
      const updatedValues = [...intermediate];

      if (
        selectedRowIndex !== null &&
        selectedRowIndex >= 0 &&
        selectedRowIndex < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndex, 1);
        // if (hist === true) {
        //   DeleteRouteMasterDetails(updatedValues[selectedRowIndex].FROMCITY);
        // }
        setselectedRowIndex(null);
      } else {
        // if (hist === true) {
        //   DeleteRouteMasterDetails(
        //     updatedValues[updatedValues.length - 1].FROMCITY,
        //   );
        // }
        updatedValues.pop();
      }
      clearAll();
      setInterMediate(updatedValues);
      if (updatedValues.length === 0) {
        setShowIntermediate(false);
      }
    } else {
      alert("Please add Intermediate details First");
    }
  };

  const handleInterMediate = (value, index) => {
    setselectedRowIndex(index);
    setInterDistance(value.DISTANCE);
    setSelInterFrom(value.FROMCITY);
    setSelInterTo(value.TOCCITY);
  };

  const handleRowClick = (value, index) => {
    ClearAllInputs();
    clearAll();
    sethist(true);
    setShowIntermediate(true);
    setrouteend(false);
    setNewRouteId(value.OM_ROUTE_ID);
    setSelfrom(value.OM_ROUTE_START);
    setSelto(value.OM_ROUTE_END);
    setDistance(value.OM_ROUTE_DISTANCE);
    setDaysToTake(value.OM_ROUTE_DAYS);
    setRouteName(value.OM_ROUTE_NAME);
    setisLocal(value.OM_ROUTE_LOCAL == 1 ? true : false);
    // setSelExportImport(value.OM_ROUTE_EXPORT_IMPORT);
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=651&ROUTEID=${value.OM_ROUTE_ID}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        console.log(response.data);
        setInterMediate(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Intermediate Route details:", error);
      });
  };

  const ClearAllInputs = () => {
    setSelfrom("");
    setSelto("");
    setDistance("");
    setDaysToTake("");
    // setSelExportImport("");
    setRouteName("");
    setisLocal(false);
  };

  // ****************************************************************************************************
  // Saving
  async function SaveRouteMasterHeader() {
    if (!selfrom) {
      alert("Kindly Supply From Location");
      return;
    }

    if (!selto) {
      alert("Kindly Supply To Location");
      return;
    }

    if (!routeName) {
      alert("Kindly Supply Route Name");
      return;
    }

    if (!daystotake) {
      alert("Kindly Supply Days to Take");
      return;
    }

    if (intermediate?.length === 0) {
      alert("Kindly Add Intermediate Route");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=937`,
        {
          ROUTEID: Number(newRouteId),
          ROUTELOCAL: islocal == true ? 1 : 0,
          ROUTEFROM: selfrom,
          ROUTETO: selto,
          ROUTEDISTANCE: Number(distance),
          ROUTENAME: routeName,
          ROUTEDAYTOTAKE: Number(daystotake),
          ROUTEEXPORTIMPORT: "",
          CREATEDBY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        alert("Route Master Header Saved Successfully");
        await SaveRouteMasterDetails();
        setIsLoading(false);
        window.location.reload();
      } else {
        alert("Error while saving Route Master");
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(`Error while saving Route Master `, error);
      alert(error.response.data.message);
    }
  }

  async function SaveRouteMasterDetails() {
    setIsLoading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    for (let index = 0; index < intermediate.length; index++) {
      const value = intermediate[index];
      try {
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=695`,
          {
            ROUTEID: Number(newRouteId),
            ROUTEFROM: value.FROMCITY,
            ROUTETO: value.TOCCITY,
            ROUTEDISTANCE: Number(value.DISTANCE),
            CREATEDBY: user,
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } catch (error) {
        setIsLoading(false);
        console.error(`Error while Saving Intermediate Routes `, error);
        alert(error.response.data.message);
      }
    }
    setIsLoading(false);
    if (successCount == intermediate.length && successMessage) {
      alert("Intermediate Route Saved Successfully");
    }
    if (errorMessage) {
      alert("Error while Saving Intermediate Routes");
    }
  }

      // *************** EXPORT TO EXCEL OR PDF ****************************
  
      const ExcelStockData = () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("REGISTERED ROUTES");
        const rows = document.querySelectorAll(".table_1 tbody tr");
    
        const columnWidths = [10, 15, 15, 15,15];
    
        // Set column widths for the worksheet
        columnWidths.forEach((width, index) => {
          worksheet.getColumn(index + 1).width = width;
        });
    
        // Add headers
        const headerRow = worksheet.addRow([
          "ROUTE ID",
          "FROM LOCATION",
          "TO LOCATION",
          "ROUTE NAME",
          "DISTANCE",
        ]);
        headerRow.eachCell((cell) => {
          cell.font = { bold: true };
        });
    
        // Add rows from the table
        rows.forEach((row) => {
          const rowData = [];
          row.querySelectorAll("td").forEach((cell) => {
            rowData.push(cell.textContent);
          });
          worksheet.addRow(rowData);
        });
    
        // Create a blob from the workbook
        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "REGISTERED_ROUTES.xlsx";
          link.click();
        });
      };
    
      const PdfStockData = () => {
        const doc = new jsPDF();
    
        doc.text("REGISTERED ROUTES- Report", 10, 10);
    
        const columns = [
          "ROUTE ID",
          "FROM LOCATION",
          "TO LOCATION",
          "ROUTE NAME",
          "DISTANCE",
        ];
    
        const data = filteredData.map((stock,index) => {  
          return [
            stock.OM_ROUTE_ID,
            stock.OM_ROUTE_START,
            stock.OM_ROUTE_END,
            stock.OM_ROUTE_NAME,
            stock.OM_ROUTE_DISTANCE,
          ];
        });
    
        doc.autoTable({
          head: [columns],
          body: data,
          startY: 20,
          showHead: "firstPage",
        });
    
        doc.save("REGISTERED_ROUTES.pdf");
      };

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-100vh">
      <section className="block print:hidden">
        <AllPagesNavbar />
        <header className="header__of__main lg:flex justify-between items-end px-3">
          <h1 className="header__of__page">{"ROUTE MASTER"}</h1>
        </header>

        <div className="flex gap-2 mt-2 items-center text-gray-700 pl-2">
          <IoDocumentOutline
            size={24}
            onClick={() => {
              window.location.reload();
            }}
            className="text-blue-800  hover:text-blue-900 transition-all duration-200 drop-shadow-md"
          />
          <FaSave
            size={24}
            onClick={async () => {
              await SaveRouteMasterHeader();
            }}
            className="text-green-400 hover:text-green-500 transition-all duration-200 drop-shadow-md"
          />
          <GiCrossMark
            size={24}
            className="text-red-400 hover:text-red-500 transition-all duration-200 drop-shadow-md"
          />
          <IoPrintSharp
            size={24}
            className="text-purple-400 hover:text-purple-500 transition-all duration-200 drop-shadow-md"
          />
        </div>

        <div className="lg:flex lg:flex-col text-xs mt-2 justify-between bg-gray-100 p-4 mx-10 rounded-md">
          <div className="flex justify-end text-xs">
            <button className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
              Print Route List
            </button>
          </div>

          <div className="flex flex-col mt-1 border">
            <span className="text-sm text-red-500 ml-2">Main Route</span>
            <div className="flex items-center">
              <span className="lg:ml-2">Route Id :</span>
              <input
                className="w-20 text-right h-7 lg:ml-5 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="text"
                value={newRouteId}
                readOnly
              ></input>
              <button
                className="flex h-7 lg:ml-1 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  setPopupOpen(true);
                }}
              >
                ...
              </button>

              {isPopupOpen && (
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black h-[500px] lg:w-[1100px] w-[98%] p-1 overflow-y-auto">
                  <div className="flex flex-row mt-2">
                    <p className="text-red-600 ml-2">Search:</p>
                    <input
                      className="lg:w-64 w-48 h-8 border border-black ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                      type="text"
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                    ></input>
                  </div>
                  <button
                    className="absolute top-2 right-2 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                    onClick={() => setPopupOpen(false)}
                  >
                    Close
                  </button>
                  <aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
                       <div className="flex justify-end gap-2">
                                                        <div className="cursor-pointer">
                                                          <RiFileExcel2Line onClick={ExcelStockData} size={25} />
                                                        </div>
                                                        <div className="cursor-pointer">
                                                          <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
                                                        </div>
                                                      </div>
                    <table className="w-auto border border-gray-300 text-sm table_1">
                      <thead class="sticky top-0 w-44">
                        <tr className="bg-[#2b3f5c] text-white text-[12px]">
                          <td className="py-2 px-4  border border-gray-300 text-right">
                            ROUTE ID
                          </td>
                          <td className="py-2 px-4  border border-gray-300 text-left">
                            FROM LOCATION
                          </td>
                          <td className="py-2 px-4  border border-gray-300 text-left">
                            TO LOCATION
                          </td>
                          <td className="py-2 px-4  border border-gray-300 text-left">
                            ROUTE NAME
                          </td>
                          <td className="py-2 px-4  border border-gray-300 text-right">
                            DISTANCE
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData?.map((row, index) => (
                          <tr
                            className="hover:bg-gray-100 cursor-pointer text-[12px]"
                            key={index}
                            onClick={() => {
                              setPopupOpen(false);

                              handleRowClick(row, index);
                            }}
                          >
                            <td className="text-right pr-6 py-2 px-4 border border-gray-300">
                              {row?.OM_ROUTE_ID ? row?.OM_ROUTE_ID : "N/A"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {row?.OM_ROUTE_START
                                ? row?.OM_ROUTE_START
                                : "N/A"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {row?.OM_ROUTE_END ? row?.OM_ROUTE_END : "N/A"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {row?.OM_ROUTE_NAME ? row?.OM_ROUTE_NAME : "N/A"}
                            </td>
                            <td className="text-right pr-6 py-2 px-4 border border-gray-300">
                              {row?.OM_ROUTE_DISTANCE
                                ? row?.OM_ROUTE_DISTANCE.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )
                                : "N/A"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </aside>
                </div>
              )}
              <input
                className="w-auto lg:ml-2 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="checkbox"
              ></input>
              <span className="lg:ml-2">Local</span>
              <select
                className="w-36 common-input mr-[180px] lg:ml-2"
                type="text"
              ></select>
              <button
                className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  setShowCityMaster(true);
                }}
              >
                Add Location
              </button>

              {showCityMaster && (
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[550px] h-[80%] lg:w-[950px] w-[95%] p-1 overflow-y-auto z-[500]">
                  <CityMaster hideNavbar={true} />

                  <button
                    className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                    onClick={() => setShowCityMaster(false)}
                  >
                    Close
                  </button>
                </div>
              )}
            </div>

            <div className="flex items-center lg:mt-2">
              <span className="lg:ml-2">From :</span>
              {/* <input
                className="w-36 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="text"
                value={selfrom}
                onChange={(e) => setSelfrom(e.target.value)}
              ></input>
              <button className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
                ...
              </button> */}

              <Select
                className="w-96 lg:ml-10"
                onChange={(selectedOption) => {
                  if (selectedOption.value === "") {
                    alert("Kinly select Proper Category");
                  } else {
                    setSelfrom(selectedOption.value);
                  }
                }}
                value={
                  selfrom
                    ? {
                        label: selfrom,
                        value: selfrom,
                      }
                    : { label: "Select From Location", value: "" }
                }
                options={[
                  ...citylist.map((item) => ({
                    value: item.OM_CITY_CODE,
                    label: item.OM_CITY_CODE,
                  })),
                ]}
                isDisabled={hist == true}
              />

              <span className="lg:ml-[40px]">To :</span>
              {/* <input
                className="w-36 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="text"
                value={to}
                onChange={(e) => setTo(e.target.value)}
              ></input>
              <button className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
                ...
              </button> */}

              <Select
                className="w-96 lg:ml-2"
                onChange={(selectedOption) => {
                  if (selectedOption.value === "") {
                    alert("Kinly select Proper Category");
                  } else if (!selfrom) {
                    alert("Kindly Supply From location first");
                  } else if (selectedOption.value == selfrom) {
                    alert("To location cannot be same a From location");
                  } else {
                    setSelto(selectedOption.value);
                    setSelInterTo(selectedOption.value);
                    setSelInterFrom(selfrom);
                  }
                }}
                value={
                  selto
                    ? {
                        label: selto,
                        value: selto,
                      }
                    : { label: "Select To Location", value: "" }
                }
                options={[
                  ...citylist.map((item) => ({
                    value: item.OM_CITY_CODE,
                    label: item.OM_CITY_CODE,
                  })),
                ]}
                isDisabled={hist == true}
              />

              <div className="lg:ml-2 flex flex-col items-end">
                <span className="lg:ml-2 text-sm">
                  Days To Take (For Highway Route)
                </span>
                <input
                  className="w-36 h-8"
                  type="text"
                  value={daystotake}
                  onChange={(e) => setDaysToTake(e.target.value)}
                ></input>
              </div>
            </div>

            <div className="flex items-center lg:mt-1">
              <span className="lg:ml-2">Route Name :</span>
              <input
                className="w-96 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="text"
                value={routeName}
                onChange={(e) => setRouteName(e.target.value)}
              ></input>
            </div>
          </div>

        <aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
            <table className="w-auto border border-gray-300 text-sm">
              <thead class="sticky top-0 w-44">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
                  <td className="py-2 px-4 border border-gray-300 text-right">S NO</td>
                  <td className="py-2 px-4 border border-gray-300 text-right">ROUTE ID</td>
                  <td className="py-2 px-4 border border-gray-300 text-left">FROM</td>
                  <td className="py-2 px-4 border border-gray-300 text-left">TO</td>
                  {/* <td className="py-2 px-4 border border-gray-300 text-right">DISTANCE</td> */}
                  <td className="py-2 px-4 border border-gray-300 text-left">ROUTE NAME</td>
                  <td className="py-2 px-4 border border-gray-300 text-right">DAYS</td>
                </tr>
              </thead>
              <tbody>
                {data.map((row, index) => (
                  <tr
                   className="hover:bg-gray-100 cursor-pointer text-[12px]"
                    key={index}
                    onClick={() => {
                      setNewRouteId(row?.OM_ROUTE_ID);
                      setSelfrom(row?.OM_ROUTE_START);
                      setSelto(row?.OM_ROUTE_END);
                      setRouteName(row?.OM_ROUTE_NAME);
                      setDaysToTake(row?.OM_ROUTE_DAYS);
                    }}
                  >
                    <td className="py-2 px-4 border border-gray-300 text-right">{index + 1}</td>
                    <td className="py-2 px-4 border border-gray-300 text-right">
                      {row.OM_ROUTE_ID ? row.OM_ROUTE_ID : "N/A"}
                    </td>
                    <td className="py-2 px-4 border border-gray-300 text-left">
                      {row.OM_ROUTE_START ? row.OM_ROUTE_START : "0"}
                    </td>
                    <td className="py-2 px-4 border border-gray-300 text-left">
                      {row.OM_ROUTE_END ? row.OM_ROUTE_END : "0"}
                    </td>
                    {/* <td className="py-2 px-4 border border-gray-300 text-right">
                      {row.OM_ROUTE_DISTANCE ? row.OM_ROUTE_DISTANCE : "0"}
                    </td> */}
                    <td className="py-2 px-4 border border-gray-300 text-left">
                      {row.OM_ROUTE_NAME ? row.OM_ROUTE_NAME : "0"}
                    </td>
                    <td className="py-2 px-4 border border-gray-300 text-right">
                      {row.OM_ROUTE_DAYS ? row.OM_ROUTE_DAYS : "0"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </aside>

          <div className="flex flex-col mt-1 border">
            <span className="text-sm text-red-500 ml-3">
              Intermediate Route
            </span>

            <div className="flex items-center">
              <span className="lg:ml-2">From :</span>
              {/* <input
                className="w-36 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="text"
              ></input>
              <button className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
                ...
              </button> */}

              <Select
                className="w-96 lg:ml-6"
                onChange={(selectedOption) => {
                  if (!selfrom || !selto) {
                    alert("Kindly Select Main Route From and To Details");
                  } else {
                    setSelInterFrom(selectedOption.value);
                  }
                }}
                value={
                  selInterFrom
                    ? {
                        label: selInterFrom,
                        value: selInterFrom,
                      }
                    : { label: "Select From Location", value: "" }
                }
                options={[
                  ...citylist.map((item) => ({
                    value: item.OM_CITY_CODE,
                    label: item.OM_CITY_CODE,
                  })),
                ]}
                isDisabled={routeend == true || intermediate.length > 0}
              />

              <span className="lg:ml-2">To :</span>
              {/* <input
                className="w-36 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="text"
              ></input>
              <button className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
                ...
              </button> */}

              <Select
                className="w-96 lg:ml-2"
                onChange={(selectedOption) => {
                  if (!selfrom || !selto) {
                    alert("Kindly Select Main Route From and To Details");
                  } else {
                    if (selectedOption.value == selInterFrom) {
                      alert("To Location Cannot be Same as From Location");
                    } else {
                      setSelInterTo(selectedOption.value);
                    }
                  }
                }}
                value={
                  selInterTo
                    ? {
                        label: selInterTo,
                        value: selInterTo,
                      }
                    : { label: "Select To Location", value: "" }
                }
                options={[
                  ...citylist.map((item) => ({
                    value: item.OM_CITY_CODE,
                    label: item.OM_CITY_CODE,
                  })),
                ]}
                isDisabled={routeend == true}
              />

              <button className="flex h-7 lg:ml-2 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
                Remove from bottom
              </button>
            </div>

            <div className="flex items-center lg:mt-2">
              <span className="lg:ml-2">Distance :</span>
              <input
                className="w-36 h-7 lg:ml-1 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="number"
                value={interdistance}
                onChange={(e) => setInterDistance(e.target.value)}
              ></input>
              <span className="lg:ml-2">(Km)</span>
              <span className="lg:ml-2">Total Dist(Km) :</span>
              {/* <input
                className="w-36 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="text"
              ></input> */}

              <input
                className="w-48 border border-black rounded-md px-2 lg:ml-2 py-1"
                type="number"
                value={interdistance}
                onChange={(e) => {
                  if (!selfrom || !selto) {
                    alert("Kindly Select Main Route From and To Details");
                  } else {
                    if (!routeName) {
                      alert("Kindly Provide Route name");
                      setInterDistance("");
                    } else if (!daystotake) {
                      alert("Kindly Provide days to take");
                      setInterDistance("");
                    } else {
                      setInterDistance(e.target.value);
                    }
                  }
                }}
                disabled={routeend == true}
              />

              <button
                className="flex h-7 lg:ml-80  items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  if (routeend == true) {
                    alert("You have reached to the end of Main Route");
                  } else {
                    AddIntermediate();
                  }
                }}
              >
                Add
              </button>
              <button
                className="flex h-7 lg:ml-2 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  RemoveInterMediate();
                }}
              >
                Remove from top
              </button>
            </div>
          </div>
        </div>

        {showInterMediate && (
             <aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
            <table className="w-auto border border-gray-300 text-sm">
              <thead class="sticky top-0 w-44">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
                  <td className="py-2 px-4  border border-gray-300 text-left">FROM LOCATION</td>
                  <td className="py-2 px-4  border border-gray-300 text-left">TO LOCATION</td>
                  <td className="text-right py-2 px-4  border border-gray-300">DISTANCE</td>
                </tr>
              </thead>
              <tbody>
                {intermediate.map((value, index) => (
                  <tr
                    onClick={() => {
                      handleInterMediate(value, index);
                    }}
                    className="hover:bg-gray-100 cursor-pointer text-[12px]"
                    key={index}
                  >
                    <td  className="py-2 px-4  border border-gray-300 text-left">{value.FROMCITY ? value.FROMCITY : "N/A"}</td>
                    <td  className="py-2 px-4  border border-gray-300 text-left">{value.TOCCITY ? value.TOCCITY : "N/A"}</td>
                    <td className="text-right py-2 px-4  border border-gray-300">
                      {value.DISTANCE
                        ? value.DISTANCE.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="mt-6 flex justify-end gap-2">
              <label className="block text-gray-700">Total Distance</label>
              <input
                className="w-48 border border-black rounded-md px-2 py-1 text-right"
                type="number"
                value={
                  distance
                    ? distance.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : ""
                }
                readOnly
              />
            </div>
          </aside>
        )}
      </section>
    </div>
  );
};
export default RouteMasterLog;
